import 'unfetch/polyfill';
import ky from 'ky';

const client = ky.create({});

export default client;
